import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { Styles } from './styles';
import { currency } from '../../../utils/functions';
import { RHeader, RPage, RViewer } from '../../../../components/PdfRender';
import { useCompany } from '../../../../hooks/company';
import { ITreatment } from '../../../interfaces';

interface IProps {
  data: ITreatment[];
  period: string;
}

export const TreatmentsProductionReport: React.FC<IProps> = ({
  data,
  period,
}) => {
  const { company } = useCompany();

  return (
    <RViewer>
      <RPage size="A4">
        <View style={Styles.container}>
          <RHeader company={company} />
          <View style={Styles.header}>
            <Text style={Styles.title}>Relatório de Produção</Text>
            <Text style={Styles.subtitle}>Período: {period}</Text>
          </View>

          <View style={Styles.table}>
            <View style={Styles.tableRow}>
              <View style={{ ...Styles.tableColHeader, width: '40%' }}>
                <Text style={Styles.tableCellHeader}>Profissional</Text>
              </View>
              <View style={{ ...Styles.tableColHeader, width: '20%' }}>
                <Text style={Styles.tableCellHeader}>Qtd. Trat.</Text>
              </View>
              <View style={{ ...Styles.tableColHeader, width: '20%' }}>
                <Text style={Styles.tableCellHeader}>Total Produção</Text>
              </View>
              <View style={{ ...Styles.tableColHeader, width: '20%' }}>
                <Text style={Styles.tableCellHeader}>Comissão</Text>
              </View>
            </View>

            {data.map((item, index) => (
              <View key={index} style={Styles.tableRow}>
                <View style={{ ...Styles.tableCol, width: '40%' }}>
                  <Text style={Styles.tableCell}>{item.professional_name}</Text>
                </View>
                <View style={{ ...Styles.tableCol, width: '20%' }}>
                  <Text style={Styles.tableCell}>{item.total}</Text>
                </View>
                <View style={{ ...Styles.tableCol, width: '20%' }}>
                  <Text style={Styles.tableCell}>
                    {currency(item.total_production ?? 0)}
                  </Text>
                </View>
                <View style={{ ...Styles.tableCol, width: '20%' }}>
                  <Text style={Styles.tableCell}>
                    {currency(item.total_commission ?? 0)}
                  </Text>
                </View>
              </View>
            ))}
          </View>

          <Text
            style={Styles.footer}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            fixed
          />
        </View>
      </RPage>
    </RViewer>
  );
};
